import NicknameBar from '../components/NicknameBar';

interface PollWaitingScreenProps {
  message: string;
}

function PollWaitingScreen({ message }: PollWaitingScreenProps) {
  return (
    <div className="flex items-center justify-center min-h-screen p-4 pt-10">
      <NicknameBar />
      <div className="text-center">
        <div className="animate-pulse mb-6">
          <div className="w-16 h-16 border-4 border-parchment-300 border-t-parchment-400 rounded-full animate-spin mx-auto"></div>
        </div>
        <p className="text-2xl font-heading text-ink-light">{message}</p>
      </div>
    </div>
  );
}

export default PollWaitingScreen;
